// CropImage.jsx
import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
} from "react-image-crop";
import { canvasPreview } from "./canvasPreview";
import { useDebounceEffect } from "./useDebounceEffect";
import "react-image-crop/dist/ReactCrop.css";
import { base64ToImage } from "../../utilis/common-funtions";

function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
  return centerCrop(
    makeAspectCrop(
      { unit: "%", width: 90 },
      aspect,
      mediaWidth,
      mediaHeight
    ),
    mediaWidth,
    mediaHeight
  );
}

const CropImage = ({ selectedFiles, onCroppedImageReady,rotate }) => {
  const [imgSrc, setImgSrc] = useState("");
  const previewCanvasRef = useRef(null);
  const imgRef = useRef(null);
  const [crop, setCrop] = useState();
  const [completedCrop, setCompletedCrop] = useState();
  const [scale, setScale] = useState(1);
  const [aspect, setAspect] = useState(undefined);

  useEffect(() => {
    if (selectedFiles?.length > 0) {
      setCrop(undefined);
      const reader = new FileReader();
      reader.onload = () => setImgSrc(reader.result?.toString() || "");
      reader.readAsDataURL(selectedFiles[0]);
    }
  }, [selectedFiles]);

  function onImageLoad(e) {
    const { width, height } = e.currentTarget;
    const newCrop = aspect
      ? centerAspectCrop(width, height, aspect)
      : {
          unit: "px",
          x: 0,
          y: 0,
          width: width,
          height: height,
        };
    setCrop(newCrop);
  }

  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        await canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          scale,
          rotate
        );

        const imageDataUrl = previewCanvasRef.current.toDataURL("image/jpeg");
        const file = base64ToImage(imageDataUrl);
        onCroppedImageReady(file); // send cropped file to parent
      }
    },
    300,
    [completedCrop, scale, rotate]
  );

  return (
    <>
      {!!imgSrc && (
        <ReactCrop
          crop={crop}
          onChange={(_, percentCrop) => setCrop(percentCrop)}
          onComplete={(c) => setCompletedCrop(c)}
          aspect={aspect}
          keepSelection
          ruleOfThirds
        >
          <img
            ref={imgRef}
            alt="Crop me"
            src={imgSrc}
            onLoad={onImageLoad}
            style={{
              transform: `scale(${scale}) rotate(${rotate}deg)`,
              transformOrigin: "center",
              display: "block",
              maxWidth: "100%",
            }}
          />
        </ReactCrop>
      )}
      {/* Hidden canvas (no preview) */}
      <canvas ref={previewCanvasRef} style={{ display: "none" }} />
      
    </>
  );
};



CropImage.propTypes = {
  onCroppedImageReady: PropTypes.func,
  rotate: PropTypes.any,
  selectedFiles: PropTypes.any,
};

export default CropImage;
